import {IRouteInfoMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/types";
import {useState} from "react";
import {VoyageStatusSingleVoyage} from "@containers/singleVoyage/types/voyage";
import moment from "moment/moment";
import {getInitialBooleanValue} from "@helpers/boolean/getInitialBooleanValue";
import {StateMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/route/mutateRoute/types";
import {
    DATE_FORMAT_ROUTE_INFO_MUTATE_SINGLE_VOYAGE
} from "@containers/singleVoyage/mutateVoyage/route/constants/dateFormat";


export function useGetStateMutateRouteSingleVoyage({initial}: {
    initial?: IRouteInfoMutateSingleVoyage,
} = {}): StateMutateSingleVoyage {
    const [status, setStatus] = useState<VoyageStatusSingleVoyage>(initial?.status || 'READY_FOR_MANUAL_RUN')
    const [title, setTitle] = useState<string>(initial?.title ?? '')
    const [driverId, setDriverId] = useState<string>(initial?.driverId > 0 ? initial?.driverId.toString() : '')
    const [deviceId, setDeviceId] = useState<string>(initial?.deviceId > 0 ? initial.deviceId.toString() : '')

    const [plannedStart, setPlannedStart] = useState<string>(moment(initial?.plannedStart ?? new Date()).format(DATE_FORMAT_ROUTE_INFO_MUTATE_SINGLE_VOYAGE))
    const [plannedEnd, setPlannedEnd] = useState<string>(moment(initial?.plannedEnd ?? new Date()).format(DATE_FORMAT_ROUTE_INFO_MUTATE_SINGLE_VOYAGE))

    const [onRouteControl, setOnRouteControl] = useState<boolean>(() => getInitialBooleanValue(initial?.config?.onRouteControl, false))
    const [waypointOrderControl, setWaypointOrderControl] = useState<boolean>(() => getInitialBooleanValue(initial?.config?.waypointOrderControl, false))
    const [notification, setNotification] = useState<boolean>(() => getInitialBooleanValue(initial?.config?.notification, false))

    return {
        status, onChangeStatus: setStatus,
        title, onChangeTitle: setTitle,
        driverId, onChangeDriverId: setDriverId,
        deviceId, onChangeDeviceId: setDeviceId,
        plannedStart, onChangePlannedStart: setPlannedStart,
        plannedEnd, onChangePlannedEnd: setPlannedEnd,
        onRouteControl, onChangeOnRouteControl: setOnRouteControl,
        waypointOrderControl, onChangeWaypointOrderControl: setWaypointOrderControl,
        notification, onChangeNotification: setNotification,
    }
}